import { render } from "./NotaDeRemision.vue?vue&type=template&id=28f6ac8a&scoped=true"
import script from "./NotaDeRemision.vue?vue&type=script&lang=js"
export * from "./NotaDeRemision.vue?vue&type=script&lang=js"

import "./NotaDeRemision.vue?vue&type=style&index=0&id=28f6ac8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f6ac8a"]])

export default __exports__